import {Pagination} from 'components/Pagination';
import {ProductsPageBlock} from 'modules/products/components/ProductsPageBlock';
import {PaginationContext} from 'plugins/modules/pagination/context';
import React, {memo, useCallback, useContext, useMemo} from 'react';
import style from './style.module.scss';
import {Col} from 'components/Grid';
import {Typography} from 'components/Typography';
import {getPluralProducts} from 'core/helpers';
import {IProductShort} from 'modules/products/types';

interface IBrandXListingProps {
    products: IProductShort[];
}

export const BrandXListing = memo<IBrandXListingProps>(({products}) => {
    const {count, page, onPageClick, onAccPageChange, size} = useContext(PaginationContext);

    const canLoadMore = 0 < size && page < Math.ceil(count / size);

    const onLoadMore = useCallback(() => {
        if (canLoadMore) {
            onAccPageChange?.(page + 1);
        }
    }, [canLoadMore, onAccPageChange, page]);

    const totalPages = useMemo<number>(() => {
        if (!count) {
            return 1;
        }

        if (!size) {
            return 1;
        }

        return Math.ceil(count / size);
    }, [count, size]);

    return (
        <Col className={style.listing}>
            <Typography className={style.title} variant={'h5-medium'}>
                {count} {getPluralProducts(count)}
            </Typography>
            <ProductsPageBlock infiniteScrollActive={canLoadMore} onLoadMore={onLoadMore} products={products} />
            {onPageClick && (
                <Pagination
                    className={style.pagination}
                    currentPage={page}
                    onChange={onPageClick}
                    totalPages={totalPages}
                />
            )}
        </Col>
    );
});
